import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateAdapter extends NgbDateAdapter<string> {
  fromModel(value: string | null): NgbDateStruct | null {
    if (!value) return null;
    const parts = value.split('/');
    return {
      day: +parts[0],
      month: +parts[1],
      year: +parts[2],
    };
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? `${this.pad(date.day)}/${this.pad(date.month)}/${date.year}`
      : null;
  }

  private pad(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
}
